import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import SalesBudgetDailyInputLayout from 'components/organismos/master/storeManagement/salesBudgetYear/SalesBudgetDailyInputLayout';

const salesBudgetDailyInput = () => (
  <SidebarTemplate pageTitle="予算編成（月間）">
    <SalesBudgetDailyInputLayout />
  </SidebarTemplate>
);
export default salesBudgetDailyInput;
